export default __webpack_public_path__ + "static/media/icosahedron.e521d5ef.glb";